import { render, staticRenderFns } from "./MarketingServicesBenefits.vue?vue&type=template&id=4df5db53"
import script from "./MarketingServicesBenefits.vue?vue&type=script&lang=js"
export * from "./MarketingServicesBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports